var React = require('react');

function CircleArrowBlack (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"rotate(90 20 21)","fill":"none","fillRule":"evenodd"},[React.createElement("g",{"className":"circle","stroke":"#000","key":0},React.createElement("circle",{"stroke":"","cx":"20","cy":"20","r":"20"})),React.createElement("g",{"className":"line","fill":"#000","key":1},[React.createElement("path",{"d":"M20.016 12h1L21 27.041h-1z","key":0}),React.createElement("path",{"d":"M28.028 19.028v1l-15.04-.015v-1z","key":1})])]));
}

CircleArrowBlack.defaultProps = {"viewBox":"0 0 42 42"};

module.exports = CircleArrowBlack;

CircleArrowBlack.default = CircleArrowBlack;
